document.addEventListener('DOMContentLoaded',()=>{
  console.log('MANASHOP OS2 THEME READY');

  document.querySelectorAll('[data-product-media-carousel]').forEach((carousel)=>{
    const slides = Array.from(carousel.querySelectorAll('[data-media-slide]'));
    const thumbs = Array.from(carousel.querySelectorAll('[data-media-thumb]'));
    const prev = carousel.querySelector('[data-media-prev]');
    const next = carousel.querySelector('[data-media-next]');
    if (!slides.length) return;

    let current = slides.findIndex((slide)=>slide.classList.contains('is-active'));
    if (current < 0) current = 0;

    const pauseInactiveVideos = () => {
      slides.forEach((slide, index)=>{
        if(index === current) return;
        slide.querySelectorAll('video').forEach((video)=>video.pause());
      });
    };

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex)=>{
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach((thumb, thumbIndex)=>{
        thumb.classList.toggle('is-active', thumbIndex === current);
      });
      pauseInactiveVideos();
    };

    thumbs.forEach((thumb, index)=>thumb.addEventListener('click',()=>showSlide(index)));
    if(prev) prev.addEventListener('click',()=>showSlide(current - 1));
    if(next) next.addEventListener('click',()=>showSlide(current + 1));

    carousel.addEventListener('keydown',(event)=>{
      if(event.key === 'ArrowLeft') showSlide(current - 1);
      if(event.key === 'ArrowRight') showSlide(current + 1);
    });
  });
});
